import React,{useEffect} from "react";
import { useSelector } from "react-redux";
import { checkReplaceUrl } from "../../utils";
import { useTranslation } from 'react-i18next';

export const SupportSearchSuggestion = ({
  isOpen,
  divRef,
  loading,
  handleSuggestionClick,
  searchQuery
}) => {
  const suggestion = useSelector((state) => state?.supportSearch?.suggestion);
  const suggestionLoader = useSelector((state) => state?.supportSearch?.suggestion?.isLoading);
  useEffect(()=>{
    console.log(suggestion,'suggestion')
  },[suggestion])
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {isOpen && (
        <div
          ref={divRef}
          className="sd-absolute sd-mt-1 sd-w-full sd-bg-white sd-z-10 sd-shadow-[0_3px_8px_#00000040] sd-border  sd-border-n-gray-3 sd-font-pilat "
        >
          {(!loading && !suggestionLoader && suggestion.nodata) ?
          <p className="sd-m-2">
            {t('noSuggestion')}
          </p>:

          // <div className="sd-grid sd-grid-cols-12 sd-gap-2  lg:sd-grid-cols-12    lg:sd-items-start  sd-p-4">
          <div className="lg:sd-flex sd-justify-between sd-p-4">
            
            <div className="sd-flex-1 sd-m-2 sd-mb-6">
              {/* Skeleton loader for the list */}
              {(loading || suggestionLoader) && (
                <>
                    <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 "></h4>
                    <div className="sd-w-full">
                      <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                        {Array(5)
                          .fill(0)
                          .map((_, index) => (
                            <li
                              key={index}
                              className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-12 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                            ></li>
                          ))}
                      </ul>
                    </div>
                </>
              )}
              {!loading && suggestion?.productDoc?.length > 0 && (
                <>
                  <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                    {t('productSupportPages')}
                  </h3>
                  <ul className=" lg:sd-pr-7 sd-pr-2">
                      {suggestion.productDoc.map((item, index) => (
                        <li
                          key={index}
                          className="sd-cursor-pointer hover:sd-bg-gray-200 sd-mb-4"
                        >
                          <a
                            target="_blank"
                            href={item?.url}
                            className="sd-flex sd-items-center"
                          >
                            <span className="sd-w-[3rem] sd-h-[3rem] sd-mr-1">
                              <img className="sd-max-w-full sd-h-full sd-p-2 sd-aspectratio-[1/1]" src={item?.url+'.wdthumb.48.48.webp'}></img>
                            </span>
                            <span>{item?.title[0]}</span>
                          </a>
                        </li>
                      ))}
                  </ul>
                </>
              )}
            </div>





            <div className="sd-flex-1 sd-m-2">
              {suggestion?.software?.length > 0 && (
                <div className=" sd-w-full sd-break-words sd-mb-6">
                  <div className="sd-flex sd-justify-between lg:sd-pr-2">
                    <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                    {t('softwareDownloads')}
                    </h3>
                    <a target='_blank' href={checkReplaceUrl('https://support-en.sandisk.com/app/products/downloads/softwaredownloads')} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                      {t('viewAll')}
                    </a>
                  </div>
                  <div className="sd-w-full sd-blackhover-listitem">
                    <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                        {suggestion.software.map((item, index) => (
                          <li
                            key={index}
                            className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                          >
                            <a target="_blnk" href={checkReplaceUrl(item.url)}>
                              {item.title[0]}
                            </a>
                          </li>
                        ))}
                      </ul>
                  </div>
                </div>
              )}
              {suggestion?.knowledgeBase?.length > 0 && (
                <div className=" sd-w-full sd-break-words sd-mb-6">
                  <div className="sd-flex sd-justify-between lg:sd-pr-2">
                    <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                    {t('knowledgeBaseArticles')}
                    </h3>
                    <a target='_blank' href={checkReplaceUrl('https://shop.sandisk.com/support/search-support?viewall=knowledgeBase')} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                    {t('viewAll')}
                    </a>
                  </div>

                  <div className="sd-w-full sd-blackhover-listitem">
                    <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                        {suggestion.knowledgeBase.map((item, index) => (
                          <li
                            key={index}
                            className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                          >
                            <a target="_blnk" href={checkReplaceUrl(item.url)}>
                              {item.title[0]}
                            </a>
                          </li>
                        ))}
                      </ul>
                  </div>
                </div>
              )}
              {suggestion?.community?.length > 0 && (
                <div className="sd-w-full sd-break-words sd-mb-6">
                  <div className="sd-flex sd-justify-between lg:sd-pr-2">
                    <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                    {t('community')}
                    </h3>
                    <a target='_blank' href={checkReplaceUrl('https://shop.sandisk.com/support/search-support?viewall=community')} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                    {t('viewAll')}
                    </a>
                  </div>
                  <div className="sd-w-full sd-blackhover-listitem">
                    <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                        {suggestion.community.map((item, index) => (
                          <li
                            key={index}
                            className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                          >
                            <a target="_blnk" href={checkReplaceUrl(item.url)}>
                              {item.title[0]}
                            </a>
                          </li>
                        ))}
                      </ul>
                  </div>
                </div>
              )}
              {!loading && suggestion?.product?.length > 0 && (
                <>
                  <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                    {t('productDocumentation')}
                  </h3>
                  <ul className=" lg:sd-pr-7 sd-pr-2">
                      {suggestion.product.map((item, index) => (
                        <li
                          key={index}
                          className="sd-cursor-pointer hover:sd-bg-gray-200 sd-mb-4"
                        >
                          <a
                            target="_blank"
                            href={item.url}
                            className="sd-flex sd-items-center"
                          >
                            <span className="sd-w-[3rem] sd-h-[3rem] sd-mr-1">
                              <img className="sd-max-w-full" src={item.primaryImage}></img>
                            </span>
                            <span>{item.title[0]}</span>
                          </a>
                        </li>
                      ))}
                  </ul>
                </>
              )}
              {(loading || suggestionLoader) && (
                <>
                <div className="sd-mb-6  sd-w-full sd-break-words ">
                <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                <div className="sd-w-full">
                  <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                    {Array(3)
                      .fill(0)
                      .map((_, index) => (
                        <li
                          key={index}
                          className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                        ></li>
                      ))}
                  </ul>
                </div>
                </div>
                <div className="sd-mb-6  sd-w-full sd-break-words ">
                <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                <div className="sd-w-full">
                  <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                    {Array(3)
                      .fill(0)
                      .map((_, index) => (
                        <li
                          key={index}
                          className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                        ></li>
                      ))}
                  </ul>
                </div>
                </div>
                <div className="sd-mb-6  sd-w-full sd-break-words ">
                <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                <div className="sd-w-full">
                  <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                    {Array(3)
                      .fill(0)
                      .map((_, index) => (
                        <li
                          key={index}
                          className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                        ></li>
                      ))}
                  </ul>
                </div>
                </div>
                </>
              )}
            </div>
          </div>
        }
        </div>
      )}
    </React.Fragment>
  );
};

export default SupportSearchSuggestion;
